import React, {Component} from "react";
import {
    getCurrentFlowChart,
    getDataFromAbsenceTable,
    getDataFromCostUnitTable,
    getDataFromMachineTable,
    getDataFromOrderItemTable,
    getDataFromOrderTable,
    getDataFromPersonTable,
    getDataFromProjectTable,
    getDataFromWorkCombinationTable,
    getDataFromWorkplaceTable,
    getDataFromWorkprocessTable,
    getTable
} from "../utils/mobileUtils";
import {save as saveMobileClockwork} from "../services/http/mobileService";
import {get as getWebAppConfiguration} from "../services/http/webAppConfigurationService";
import {get as getWebAppData} from "../services/http/webAppDataService";
import LastBookingAccess from "../services/database/lastBookingAccess"
import PersonAccess from "../services/database/personAccess";
import AbsenceAccess from "../services/database/absenceAccess";
import ProjectAccess from "../services/database/projectAccess";
import OrderAccess from "../services/database/orderAccess";
import OrderItemAccess from "../services/database/orderItemAccess";
import CostUnitAccess from "../services/database/costUnitAccess";
import MachineAccess from "../services/database/machineAccess";
import WorkplaceAccess from "../services/database/workplaceAccess";
import WorkprocessAccess from "../services/database/workprocessAccess";
import SystemLogAccess from "../services/database/workprocessAccess";
import WorkCombinationAccess from "../services/database/workCombinationAccess";
import {
    absenceTable,
    costUnitTable,
    dataToServerTable,
    machineTable,
    orderItemTable,
    orderTable,
    personTable,
    projectTable,
    systemConfigurationTable,
    systemLogTable,
    workCombinationTable,
    workplaceTable,
    workprocessTable
} from "../config.json";
import {dateToString, stringToDate} from "../services/dateTimeFormat";
import MobileMenu from "./mobile/menu/mobileMenu";
import MobileRecordingShowOverview from "./mobile/recording/mobileRecordingShowOverview";
import MobileRecordingFromList from "./mobile/recording/mobileRecordingFromList";
import MobileRecordingFromTable from "./mobile/recording/mobileRecordingFromTable";
import MobileRecordingNumberList from "./mobile/recording/mobileRecordingNumberList";
import MobileRecordingAlphaNumberBlock from "./mobile/recording/mobileRecordingAlphaNumberBlock";
import MobileRecordingNumberBlock from "./mobile/recording/mobileRecordingNumberBlock";
import MobileRecordingKeyboard from "./mobile/recording/mobileRecordingKeyboard";
import MobileRecordingNfcReader from "./mobile/recording/mobileRecordingNfcReader";
import MobileRecordingHtmlInputField from "./mobile/recording/mobileRecordingHtmlInputField";
import MobileLocalBookingStorageListForm from "./mobile/form/mobileLocalBookingStorageListForm";
import MobileSystemConfigurationListForm from "./mobile/form/mobileSystemConfigurationListForm";
import MobileSystemLogListForm from "./mobile/form/mobileSystemLogListForm";
import MobileShiftPlanningListForm from "./mobile/form/mobileShiftPlanningListForm";
import MobileWorkPeriodListForm from "./mobile/form/mobileWorkPeriodListForm";
import LocalBookingStorageAccess from "../services/database/localBookingStorageAccess";
import LoginForm from "./mobile/auth/loginForm";
import http, {getApiUrl, getWithJWT, postWithJWT} from "../services/http/httpService";
import {toast} from "react-toastify";
import axios from "axios";
import WebAppDataLoading from "./webAppDataLoading";
import MobileDoorVisualisationListForm from "./mobile/form/mobileDoorVisualisationListForm";
import MobileLogisticsPlanningListForm from "./mobile/form/mobileLogisticsPlanningListForm";
import _ from "lodash";
import SystemConfigurationAccess from "../services/database/systemConfigurationAccess";

class Mobile extends Component {
    state = {
        level: [],
        flowChart: null,
        currentFlowChart: null,
        currentRecordingFlowChart: null,
        recordData: {table: "", fields: {}},
        configurationDataList: [],
        webAppDataLoading: false,
        showWebAppDataLoadingSummary: false,
        webAppDataLoadingSummary: {}
    };

    credentials = {
        username: "",
        tokens: {access_token: "", refresh_token: ""}
    };

    customerFlowChart = null;

    // alle 10 Minuten wird der Token erneuert
    refreshTokenTimerMax = 25; // TODO 10
    refreshTokenTimer = this.refreshTokenTimerMax;
    refreshTokenInterval = 60000;

    // currentPathname = null;
    // currentSearch = null;
    // unlisten = null;
    // unblock = null;

    componentDidMount = async () => {

        const {credentials} = this;
        const {configurations} = this.props;

        if ((!credentials || !credentials.username) && configurations.defaultUsername && configurations.defaultUsername.length > 0) {
            const credentials = {
                username: configurations.defaultUsername,
                password: configurations.defaultUsername
            };
            const url = getApiUrl() + "/api/login";

            // console.log("LoginForm.doSubmit(): url=", url, ", credentials=", credentials);
            const loginRequest = await http.post(url, credentials);
            this.onSetCredentials(loginRequest.data, true);

        }

        this.myInterval = setInterval(async () => {

            const {refreshTokenTimer, credentials, onSetCredentials} = this;
            this.refreshTokenTimer--;
            if (refreshTokenTimer <= 0) {
                this.refreshTokenTimer = this.refreshTokenTimerMax;

                if (
                    credentials &&
                    credentials.tokens &&
                    credentials.tokens.refresh_token
                ) {
                    const headers = {
                        Authorization: "Bearer " + credentials.tokens.access_token,
                        Accept: "application/json, text/plain, */*",
                        "Content-Type": "application/json"
                    };
                    axios.defaults.headers.common = headers;
                    let refreshTokenRequest;
                    try {
                        refreshTokenRequest = await postWithJWT(
                            credentials,
                            getApiUrl() +
                            "/oauth/access_token?grant_type=refresh_token&refresh_token=" +
                            credentials.tokens.access_token,
                            ""
                        );
                    } catch (ex) {
                    }
                    // console.log("---------------");
                    // console.log(
                    //   "Mobile.componentDidMount(): refreshTokenRequest",
                    //   refreshTokenRequest
                    // );
                    // console.log("---------------");
                    if (refreshTokenRequest && refreshTokenRequest.status) {
                        switch (refreshTokenRequest.status) {
                            case 200:
                                onSetCredentials(refreshTokenRequest.data, false);
                                break;

                            case 401:
                                this.credentials.username = "";
                                this.credentials.tokens.refresh_token = "";
                                this.setState({});
                                break;

                            default:
                        }
                    }
                }
            }
        }, this.refreshTokenInterval);
        // const { history } = this.props;
        // console.log("history", history);
        // this.unlisten = history.listen((newLocation, action, state) => {
        //   console.log(
        //     "listen",
        //     action,
        //     newLocation.pathname,
        //     newLocation.search,
        //     state,
        //     "<"
        //   );
        //   switch (action) {
        //     case "PUSH":
        //       console.log("listen-2 -> PUSH");
        //       if (
        //         newLocation.pathname !== this.currentPathname ||
        //         newLocation.search !== this.currentSearch
        //       ) {
        //         console.log("listen-3 -> IF");
        //         // Save new location
        //         this.currentPathname = newLocation.pathname;
        //         this.currentSearch = newLocation.search;

        //         // Clone location object and push it to history
        //         console.log("listen-4 -> history.push()");
        //         // push({
        //         //   level: level,
        //         //   flowChart: { ...flowChart }
        //         // });
        //         // this.props.history.push(newPath, dataMap);

        //         history.push({
        //           pathname: newLocation.pathname,
        //           search: newLocation.search
        //         });
        //       }
        //       break;

        //     case "POP":
        //       // Send user back if they try to navigate back
        //       history.go(1);
        //       break;

        //     default:
        //   }
        // });

        // this.unblock = history.block((location, action) => {
        //   console.log("block", location, action);
        //   return "Are you sure you want to leave this page?";
        //   // return false;
        // });


        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.level
        ) {
            this.prepareNewMenu(
                this.props.location.state.level,
                this.props.location.state.flowChart
            );
        } else {
            this.prepareNewMenu(null, null);
        }
    };

    componentWillUnmount() {
        // this.unlisten();
        // this.unblock();
    }

    // loadAllConfigurationData = async () => {
    //   let configurationDataList = [];
    //   const { database } = this.props;
    //   if (database) {
    //     this.recordList = await LocalBookingStorageAccess.getAll(
    //       database,
    //       dataToServerTable
    //     );
    //     if (this.recordList && this.recordList.length > 0) {
    //       for (const record of this.recordList) {
    //         const recordData = JSON.parse(record.recordData);
    //         configurationDataList.push({
    //           id: record.id,
    //           url: record.url,
    //           table: recordData.table
    //         });
    //       }
    //     }
    //   }
    //   this.setState({ configurationDataList });
    // };

    loadWebAppConfiguration = async () => {
        const {database, configurations} = this.props;
        const {credentials} = this;

        const mandatoryNumber = configurations.mandatoryNumber
        let deviceSerialNumber = configurations.deviceSerialNumber

        // TODO ???
        if (!deviceSerialNumber || deviceSerialNumber === "x")
            deviceSerialNumber = "template"

        const url =
            getApiUrl() +
            "/" +
            "secClockworkWebAppConfiguration" +
            "?" +
            `mandatoryNumber=${mandatoryNumber}` +
            "&" +
            `deviceSerialNumber=${deviceSerialNumber}`;

        // console.log("Mobile.loadWebAppConfiguration(): url=", url);
        const request = await getWebAppConfiguration(credentials, url);
        // console.log("Mobile.loadWebAppConfiguration(): sequence=", request);

        if (
            request &&
            request.data &&
            request.data.data &&
            request.data.data.terminal &&
            request.data.data.terminal.sequence
        )
            this.customerFlowChart = JSON.parse(request.data.data.terminal.sequence);
        this.prepareNewMenu(null, null);
    };

    loadWebAppData = async () => {
        const {database, configurations, handleSetConfigurations} = this.props;
        const {credentials} = this;


        const summary = {
            personCount: 0,
            absenceCount: 0,
            projectCount: 0,
            orderCount: 0,
            orderItemCount: 0,
            coustUnitCount: 0,
            machineCount: 0,
            workplaceCount: 0,
            workprocessCount: 0,
            workCombinationCount: 0
        }

        const databasePersonCount = await PersonAccess.getCount(database, personTable)
        const databaseAbsenceCount = await AbsenceAccess.getCount(database, absenceTable)
        const databaseProjectCount = await ProjectAccess.getCount(database, projectTable)
        const databaseOrderCount = await OrderAccess.getCount(database, orderTable)
        const databaseOrderItemCount = await OrderItemAccess.getCount(database, orderTable)
        const databaseCostUnitCount = await CostUnitAccess.getCount(database, costUnitTable)
        const databaseMachineCount = await MachineAccess.getCount(database, machineTable)
        const databaseWorkplaceCount = await WorkplaceAccess.getCount(database, workplaceTable)
        const databaseWorkprocessCount = await WorkprocessAccess.getCount(database, workprocessTable)
        const databaseWorkCombinationCount = await WorkCombinationAccess.getCount(database, workCombinationTable)

        const url =
            getApiUrl() +
            "/" +
            "secClockworkWebAppData" +
            "?" +
            `mandatoryNumber=${configurations.mandatoryNumber}` +
            "&" +
            `deviceSerialNumber=${configurations.deviceSerialNumber}` +
            "&" +
            `personCount=${databasePersonCount}` +
            "&" +
            `absenceCount=${databaseAbsenceCount}` +
            "&" +
            `projectCount=${databaseProjectCount}` +
            "&" +
            `orderCount=${databaseOrderCount}` +
            "&" +
            `orderItemCount=${databaseOrderItemCount}` +
            "&" +
            `costUnitCount=${databaseCostUnitCount}` +
            "&" +
            `machineCount=${databaseMachineCount}` +
            "&" +
            `workplaceCount=${databaseWorkplaceCount}` +
            "&" +
            `workprocessCount=${databaseWorkprocessCount}` +
            "&" +
            `workCombinationCount=${databaseWorkCombinationCount}`;
        // console.log("Mobile.loadWebAppData(): url=", url);

        const request = await getWebAppData(credentials, url);
        // console.log("Mobile.loadWebAppData(): data=", request);
        // console.log("Mobile.loadWebAppData(): url=", url);
        // console.log("Mobile.loadWebAppData(): credentials=", credentials);
        // console.log("Mobile.loadWebAppData(): request=", request);
        if (request && request.data && request.data.data) {

            if (request.data.data.dataType !== "update") {
                await PersonAccess.deleteAll(database, personTable)
                await AbsenceAccess.deleteAll(database, absenceTable)
                await ProjectAccess.deleteAll(database, projectTable)
                await OrderAccess.deleteAll(database, orderTable)
                await OrderItemAccess.deleteAll(database, orderItemTable)
                await CostUnitAccess.deleteAll(database, costUnitTable)
                await MachineAccess.deleteAll(database, machineTable)
                await WorkplaceAccess.deleteAll(database, workplaceTable)
                await WorkprocessAccess.deleteAll(database, workprocessTable)
                await WorkCombinationAccess.deleteAll(database, workCombinationTable)
            }

            if (request.data.data.deviceSerialNumber) {
                const deviceSerialNumberRecord = await SystemConfigurationAccess.getByName(database, systemConfigurationTable, "deviceSerialNumber")
                if (deviceSerialNumberRecord) {
                    if (deviceSerialNumberRecord.value !== request.data.data.deviceSerialNumber) {
                        await SystemConfigurationAccess.updateById(
                            database,
                            systemConfigurationTable,
                            deviceSerialNumberRecord.id,
                            {
                                name: "deviceSerialNumber",
                                value: request.data.data.deviceSerialNumber
                            }
                        )
                        const newConfigurations = {
                            ...configurations,
                            deviceSerialNumber: request.data.data.deviceSerialNumber
                        };

                        handleSetConfigurations(newConfigurations)
                    }
                } else {

                }
            }

            if (request.data.data.personList) {
                // await PersonAccess.updateCounterToZero(database, personTable);
                for (const personRecord of request.data.data.personList) {
                    summary.personCount++
                    if (personRecord.updateStatus === "delete") {
                        await PersonAccess.deleteByDbId(database, personTable, personRecord.dbId)
                    } else {
                        const searchedRecord = await PersonAccess.getByNumber(
                            database,
                            personTable,
                            personRecord.number
                        );
                        if (searchedRecord) {
                            await PersonAccess.updateById(
                                database,
                                personTable,
                                searchedRecord.id,
                                personRecord
                            );
                        } else {
                            await PersonAccess.add(database, personTable, personRecord);
                        }
                    }
                }
                // await PersonAccess.deleteWhereCounterEqualsZero(database, personTable);
            }

            if (request.data.data.absenceList) {
                // await AbsenceAccess.updateCounterToZero(database, absenceTable);
                for (const absenceRecord of request.data.data.absenceList) {
                    summary.absenceCount++
                    if (absenceRecord.updateStatus === "delete") {
                        await AbsenceAccess.deleteByDbId(database, absenceTable, absenceRecord.dbId)
                    } else {
                        const searchedRecord = await AbsenceAccess.getByNumber(
                            database,
                            absenceTable,
                            absenceRecord.number
                        );
                        if (searchedRecord) {
                            await AbsenceAccess.updateById(
                                database,
                                absenceTable,
                                searchedRecord.id,
                                absenceRecord
                            );
                        } else {
                            await AbsenceAccess.add(database, absenceTable, absenceRecord);
                        }
                    }
                }
                // await AbsenceAccess.deleteWhereCounterEqualsZero(
                //     database,
                //     absenceTable
                // );
            }

            if (request.data.data.projectList) {
                // await ProjectAccess.updateCounterToZero(database, projectTable);
                for (const projectRecord of request.data.data.projectList) {
                    summary.projectCount++
                    if (projectRecord.updateStatus === "delete") {
                        await ProjectAccess.deleteByDbId(database, projectTable, projectRecord.dbId)
                    } else {
                        const searchedRecord = await ProjectAccess.getByNumber(
                            database,
                            projectTable,
                            projectRecord.number
                        );
                        if (searchedRecord) {
                            await ProjectAccess.updateById(
                                database,
                                projectTable,
                                searchedRecord.id,
                                projectRecord
                            );
                        } else {
                            await ProjectAccess.add(database, projectTable, projectRecord);
                        }
                    }
                }
                // await ProjectAccess.deleteWhereCounterEqualsZero(
                //     database,
                //     projectTable
                // );
            }

            if (request.data.data.orderList) {
                // await OrderAccess.updateCounterToZero(database, orderTable);
                for (const orderRecord of request.data.data.orderList) {
                    summary.orderCount++
                    if (orderRecord.updateStatus === "delete") {
                        await OrderAccess.deleteByDbId(database, orderTable, orderRecord.dbId)
                    } else {
                        const searchedRecord = await OrderAccess.getByNumber(
                            database,
                            orderTable,
                            orderRecord.number
                        );
                        if (searchedRecord) {
                            await OrderAccess.updateById(
                                database,
                                orderTable,
                                searchedRecord.id,
                                orderRecord
                            );
                        } else {
                            await OrderAccess.add(database, orderTable, orderRecord);
                        }
                    }
                }
                // await OrderAccess.deleteWhereCounterEqualsZero(database, orderTable);
            }

            if (request.data.data.orderItemList) {
                // await OrderItemAccess.updateCounterToZero(database, orderItemTable);
                for (const orderItemRecord of request.data.data.orderItemList) {
                    summary.orderItemCount++
                    if (orderItemRecord.updateStatus === "delete") {
                        await OrderItemAccess.deleteByDbId(database, orderItemTable, orderItemRecord.dbId)
                    } else {
                        const searchedRecord = await OrderItemAccess.getByNumber(
                            database,
                            orderItemTable,
                            orderItemRecord.number
                        );
                        if (searchedRecord) {
                            await OrderItemAccess.updateById(
                                database,
                                orderItemTable,
                                searchedRecord.id,
                                orderItemRecord
                            );
                        } else {
                            await OrderItemAccess.add(
                                database,
                                orderItemTable,
                                orderItemRecord
                            );
                        }
                    }
                }
                // await OrderItemAccess.deleteWhereCounterEqualsZero(
                //     database,
                //     orderItemTable
                // );
            }

            if (request.data.data.costUnitList) {
                // await CostUnitAccess.updateCounterToZero(database, costUnitTable);
                for (const costUnitRecord of request.data.data.costUnitList) {
                    summary.costUnitCount++
                    if (costUnitRecord.updateStatus === "delete") {
                        await CostUnitAccess.deleteByDbId(database, costUnitTable, costUnitRecord.dbId)
                    } else {
                        const searchedRecord = await CostUnitAccess.getByNumber(
                            database,
                            costUnitTable,
                            costUnitRecord.number
                        );
                        if (searchedRecord) {
                            await CostUnitAccess.updateById(
                                database,
                                costUnitTable,
                                searchedRecord.id,
                                costUnitRecord
                            );
                        } else {
                            await CostUnitAccess.add(database, costUnitTable, costUnitRecord);
                        }
                    }
                }
                // await CostUnitAccess.deleteWhereCounterEqualsZero(
                //     database,
                //     costUnitTable
                // );
            }

            if (request.data.data.machineList) {
                // await MachineAccess.updateCounterToZero(database, machineTable);
                for (const machineRecord of request.data.data.machineList) {
                    summary.machineCount++
                    if (machineRecord.updateStatus === "delete") {
                        await MachineAccess.deleteByDbId(database, machineTable, machineRecord.dbId)
                    } else {
                        const searchedRecord = await MachineAccess.getByNumber(
                            database,
                            machineTable,
                            machineRecord.number
                        );
                        if (searchedRecord) {
                            await MachineAccess.updateById(
                                database,
                                machineTable,
                                searchedRecord.id,
                                machineRecord
                            );
                        } else {
                            await MachineAccess.add(database, machineTable, machineRecord);
                        }
                    }
                }
                // await MachineAccess.deleteWhereCounterEqualsZero(
                //     database,
                //     machineTable
                // );
            }

            if (request.data.data.workplaceList) {
                // await WorkplaceAccess.updateCounterToZero(database, workplaceTable);
                for (const workplaceRecord of request.data.data.workplaceList) {
                    summary.workplaceCount++
                    if (workplaceRecord.updateStatus === "delete") {
                        await WorkplaceAccess.deleteByDbId(database, workplaceTable, workplaceRecord.dbId)
                    } else {
                        const searchedRecord = await WorkplaceAccess.getByNumber(
                            database,
                            workplaceTable,
                            workplaceRecord.number
                        );
                        if (searchedRecord) {
                            await WorkplaceAccess.updateById(
                                database,
                                workplaceTable,
                                searchedRecord.id,
                                workplaceRecord
                            );
                        } else {
                            await WorkplaceAccess.add(
                                database,
                                workplaceTable,
                                workplaceRecord
                            );
                        }
                    }
                }
                // await WorkplaceAccess.deleteWhereCounterEqualsZero(
                //     database,
                //     workplaceTable
                // );
            }

            if (request.data.data.workprocessList) {
                // await WorkprocessAccess.updateCounterToZero(
                //     database,
                //     workprocessTable
                // );
                for (const workprocessRecord of request.data.data.workprocessList) {
                    summary.workprocessCount++
                    if (workprocessRecord.updateStatus === "delete") {
                        await WorkprocessAccess.deleteByDbId(database, workprocessTable, workprocessRecord.dbId)
                    } else {
                        const searchedRecord = await WorkprocessAccess.getByNumber(
                            database,
                            workprocessTable,
                            workprocessRecord.number
                        );
                        if (searchedRecord) {
                            await WorkprocessAccess.updateById(
                                database,
                                workprocessTable,
                                searchedRecord.id,
                                workprocessRecord
                            );
                        } else {
                            await WorkprocessAccess.add(
                                database,
                                workprocessTable,
                                workprocessRecord
                            );
                        }
                    }
                }
                // await WorkprocessAccess.deleteWhereCounterEqualsZero(
                //     database,
                //     workprocessTable
                // );

            }

            if (request.data.data.workCombinationList) {
                // await WorkCombinationAccess.updateCounterToZero(
                //     database,
                //     workCombinationTable
                // );
                for (const workCombinationRecord of request.data.data.workCombinationList) {
                    summary.workCombinationCount++
                    if (workCombinationRecord.updateStatus === "delete") {
                        await WorkCombinationAccess.deleteByDbId(database, workCombinationTable, workCombinationRecord.dbId)
                    } else {
                        const searchedRecord = await WorkCombinationAccess.getByDbId(
                            database,
                            workCombinationTable,
                            workCombinationRecord.dbId
                        );
                        if (searchedRecord) {
                            await WorkCombinationAccess.updateById(
                                database,
                                workCombinationTable,
                                searchedRecord.id,
                                workCombinationRecord
                            );
                        } else {
                            await WorkCombinationAccess.add(
                                database,
                                workCombinationTable,
                                workCombinationRecord
                            );
                        }
                    }
                }
                // await WorkCombinationAccess.deleteWhereCounterEqualsZero(
                //     database,
                //     workCombinationTable
                // );

            }

            //////////////////
            // let searchedRecord = await WorkCombinationAccess.getAllByOrderNumber(
            //     database,
            //     workCombinationTable,
            //     "105560"
            // );
            // console.log("getAllByOrderNumber()=", searchedRecord)
            // searchedRecord = await WorkCombinationAccess.getAllByOrderNumber(
            //     database,
            //     workCombinationTable,
            //     "105560"
            // );
            // console.log("getAllByOrderNumber()=", searchedRecord)
            // searchedRecord = await WorkCombinationAccess.getAllByOrderNumber(
            //     database,
            //     workCombinationTable,
            //     "126576"
            // );
            // console.log("getAllByOrderNumber()=", searchedRecord)
            //////////////////

        }

        return summary

    };

    pushNewMenu = dataMap => {
        // console.log(
        //   "Mobile.push(): level=",
        //   dataMap.level,
        //   "flowChart=",
        //   dataMap.flowChart,
        //   "currentRecordingFlowChart=",
        //   dataMap.currentRecordingFlowChart
        // );
        // es wird abwechselnd immer Mobile1 und Mobile2 aufgerufen, damit constructor() aufgerufen wird
        // wenn man sich selbst aufruft, wird constructor() naemlich nicht aufgerufen

        // folgende Zeile funktioniert nicht!!!
        // this.props.history.push({ path: newPath, search: null, state: dataMap });

        // let newPath = "/mobile2";
        // if (this.constructor.name === "Mobile2") newPath = "/mobile1";
        // this.props.history.push(newPath, dataMap);
        this.prepareNewMenu(dataMap.level, dataMap.flowChart);
    };

    prepareNewMenu = async (initLevel, initFlowChart) => {
        const {credentials} = this;
        const {configurations} = this.props;
        let newLevel = [];
        let newFlowChart = {};
        let newCurrentFlowChart = {};
        let newCurrentRecordingFlowChart = {};
        let newRecordData = {table: "", fields: {}};

        if (initLevel && initFlowChart) {
            newLevel = [...initLevel];
            newFlowChart = {...initFlowChart};
        } else {
            newLevel = [];

            // if (credentials.username) {
            //   const url =
            //     getApiUrl() +
            //     "/secClockworkWebAppConfiguration" +
            //     `?mandatoryNumber=${configurations.mandatoryNumber}&deviceSerialNumber=${configurations.deviceSerialNumber}`;
            //   const request = await getWithJWT(credentials, url);
            //   // console.log("Mobile.prepareNewMenu(): request=", request);
            //   newFlowChart = request.data.data.terminal.sequence;
            //   console.log("newFlowChart=", newFlowChart);

            if (this.customerFlowChart === null) {
                newFlowChart = {
                    config: {},
                    lists: [],
                    tables: [],
                    menus: []
                };
            } else {
                newFlowChart = {...this.customerFlowChart};
            }
            //   console.log("getTestData()=", JSON.stringify(getTestData()));
            // }
        }

        newCurrentFlowChart = getCurrentFlowChart(newFlowChart, newLevel);
        switch (newCurrentFlowChart.type) {
            case undefined:
            case "menu":
                break;

            case "recording":
                // console.log("TODO-2a: getNextRecordingFlowChart", newCurrentRecordingFlowChart, newRecordData)

                const table = getTable(newFlowChart, newCurrentFlowChart);
                if (table) {
                    newRecordData.table = table.name;
                    for (const field of table.fields) {
                        newRecordData.fields[field.name] = field.defaultValue;
                        newRecordData.fields[`${field.name}Display`] = field.defaultValue;
                    }
                }
                // this.setState({
                //     recordData: newRecordData
                // });
                this.state.recordData = newRecordData;  // dirty, aber this.setState ist zu langsam
                // console.log("TODO-2b: getNextRecordingFlowChart", newCurrentRecordingFlowChart, newRecordData)

                newCurrentRecordingFlowChart = await this.getNextRecordingFlowChart( //async
                    newCurrentFlowChart,
                    newCurrentRecordingFlowChart
                );
                // console.log("TODO-2c: getNextRecordingFlowChart", newCurrentRecordingFlowChart, newRecordData)
                break;

            case "localBookingStorage":
            case "systemConfiguration":
            case "systemLog":
            case "shiftPlanning":
            case "doorVisualisation":
            case "workPeriod":
            case "logisticsPlanning":
            default:
                break;
        }

        this.setState({
            level: newLevel,
            flowChart: newFlowChart,
            currentFlowChart: newCurrentFlowChart,
            currentRecordingFlowChart: newCurrentRecordingFlowChart,
            recordData: newRecordData
        });
    };

    sendDataToServer = async (flowChart, recordData) => {
        const {configurations} = this.props;
        const result = await this.sendDataToServerByUrlAndData(
            `/unsecClockworkMobile?mandatoryNumber=${configurations.mandatoryNumber}`,
            recordData
        );
        // console.log("sendDataToServer(): result =", result);
        if (result === true) {
            this.sendLocalBookingStorageToServer();
        } else {
            this.saveDataToLocalBookingStorage("/unsecClockworkMobile", recordData);
        }
    };

    sendLocalBookingStorageToServer = async () => {
        const {database, configurations} = this.props;
        if (database) {
            const recordList = await LocalBookingStorageAccess.getAll(
                database,
                dataToServerTable
            );
            if (recordList && recordList.length > 0) {
                for (const record of recordList) {
                    const recordData = JSON.parse(record.recordData);
                    recordData["offline"] = true;
                    if (
                        (await this.sendDataToServerByUrlAndData(
                            record.url + `?mandatoryNumber=${configurations.mandatoryNumber}`,
                            recordData
                        )) === true
                    ) {
                        LocalBookingStorageAccess.deleteById(
                            database,
                            dataToServerTable,
                            record.id
                        );
                    } else {
                        break;
                    }
                }
            }
        }
    };

    sendDataToServerByUrlAndData = async (url, recordData) => {
        let error = false;
        const {credentials} = this;
        let result = null;
        try {
            result = await saveMobileClockwork(
                credentials,
                getApiUrl() + url,
                recordData
            );
            // console.log("sendDataToServerByUrlAndData(): result =", result);
            if (result && result.data && result.data.error === false) {
                // all is well
            } else {
                // console.log("sendDataToServerByUrlAndData(): -> error = true");
                error = true;
            }
        } catch (ex) {
            // console.log("sendDataToServerByUrlAndData(): exception! -> error = true");
            error = true;
        }

        if (error) {
            toast.error(
                "Fehler bei Serververbindung - die Daten werden lokal gespeichert!",
                {
                    autoClose: 10000
                }
            );
        }

        // console.log("---------------");
        // console.log("result=", result);
        // console.log("---------------");
        if (result && result.status === 401) {
            this.credentials.username = "";
            this.setState({});
        }

        return !error;
    };

    saveDataToLocalBookingStorage = async (url, recordData) => {
        const {database} = this.props;
        try {
            if (database) {
                await LocalBookingStorageAccess.add(
                    this.props.database,
                    dataToServerTable,
                    {
                        url: url,
                        recordData: JSON.stringify(recordData)
                    }
                );
            } else {
                toast.error(
                    "Die Daten können lokal nicht gespeichert werden und gehen verloren!",
                    {
                        autoClose: 15000
                    }
                );
            }
        } catch (ex) {
            toast.error(
                "Die Daten können lokal nicht gespeichert werden und gehen verloren!",
                {
                    autoClose: 15000
                }
            );
        }
    };

    setRecordDataField = (tableField, value, displayValue) => {
        const {recordData} = this.state;
        let newRecordData = {...recordData};

        newRecordData.fields[tableField] = value;
        newRecordData.fields[`${tableField}Display`] = displayValue;

        this.setRecordData(newRecordData);
    };

    setRecordDataFieldAndDbId = (dbIdTableField, dbId, tableField, value, displayValue) => {
        const {recordData} = this.state;
        let newRecordData = {...recordData};

        newRecordData.fields[dbIdTableField] = dbId;
        newRecordData.fields[tableField] = value;
        newRecordData.fields[`${tableField}Display`] = displayValue;

        this.setRecordData(newRecordData);
    };

    setRecordData = recordData => {
        this.setState({recordData});
    };

    setCurrentRecordingFlowChart = currentRecordingFlowChart => {
        this.setState({currentRecordingFlowChart});
    };

    saveLastBooking = async (personDbId, tableName, data) => {

        const {database} = this.props;
        if (!personDbId || !tableName)
            return

        const newData = {}

        if (data.fields["absenceDbId"])
            newData["absenceDbId"] = data.fields["absenceDbId"];
        if (data.fields["projectDbId"])
            newData["projectDbId"] = data.fields["projectDbId"];
        if (data.fields["orderDbId"])
            newData["orderDbId"] = data.fields["orderDbId"];
        if (data.fields["orderItemDbId"])
            newData["orderItemDbId"] = data.fields["orderItemDbId"];
        if (data.fields["costUnitDbId"])
            newData["costUnitDbId"] = data.fields["costUnitDbId"];
        if (data.fields["machineDbId"])
            newData["machineDbId"] = data.fields["machineDbId"];
        if (data.fields["workplaceDbId"])
            newData["workplaceDbId"] = data.fields["workplaceDbId"];
        if (data.fields["workprocessDbId"])
            newData["workprocessDbId"] = data.fields["workprocessDbId"];

        const lastBookingRequest = await LastBookingAccess.getByPersonAndTable(database, personDbId, tableName)
        if (!lastBookingRequest) {
            await LastBookingAccess.add(database, personDbId, tableName, newData)
        } else {
            await LastBookingAccess.updateByPersonAndTable(database, personDbId, tableName, newData)
        }

    }
    getNextRecordingFlowChart = async (currentFlowChart, currentRecordingFlowChart) => { //async
        // console.log("TODO: getNextRecordingFlowChart")
        const {flowChart, recordData} = this.state;
        const {sendDataToServer, setRecordDataField} = this;
        const {database} = this.props;

        let newCurrentRecordingFlowChart = {...currentRecordingFlowChart};

        while (true) {

            if (
                newCurrentRecordingFlowChart === null ||
                newCurrentRecordingFlowChart === undefined ||
                newCurrentRecordingFlowChart.id === null ||
                newCurrentRecordingFlowChart.id === undefined
            ) {
                if (currentFlowChart.items.length === 0) {
                    newCurrentRecordingFlowChart = null;
                } else {
                    newCurrentRecordingFlowChart = currentFlowChart.items[0];
                }
            } else {
                newCurrentRecordingFlowChart = currentFlowChart.items.find(item => {
                    return item.id > newCurrentRecordingFlowChart.id;
                });
            }
            if (
                newCurrentRecordingFlowChart === null ||
                newCurrentRecordingFlowChart === undefined
            ) {
                return null;
            }

            switch (newCurrentRecordingFlowChart.type) {

                case "save":
                    this.saveLastBooking(recordData["fields"]["personDbId"], recordData["table"], recordData)
                    sendDataToServer(flowChart, recordData);
                    break;

                case "calculation":
                    let fields = {...this.state.recordData.fields};
                    let value = "";
                    let displayValue = "";
                    if (newCurrentRecordingFlowChart.calculation) {
                        try {
                            value = "" + eval(newCurrentRecordingFlowChart.calculation);
                        } catch (ex) {
                            console.log(
                                "error in Mobile.getNextRecordingFlowChart(): newCurrentRecordingFlowChart.calculation=",
                                newCurrentRecordingFlowChart.calculation,
                                ex.message
                            );
                        }
                    }
                    if (newCurrentRecordingFlowChart.displayCalculation) {
                        try {
                            displayValue =
                                "" + eval(newCurrentRecordingFlowChart.displayCalculation);
                        } catch (ex) {
                            console.log(
                                "error in Mobile.getNextRecordingFlowChart(): newCurrentRecordingFlowChart.displayCalculation=",
                                newCurrentRecordingFlowChart.displayCalculation,
                                ex.message
                            );
                        }
                    }

                    setRecordDataField(
                        newCurrentRecordingFlowChart.tableField,
                        value,
                        displayValue
                    );
                    break;

                case "httpGetRequest":
                    // const func1 = async newCurrentRecordingFlowChart => {
                    const data = await this.getHttpRequest(
                        newCurrentRecordingFlowChart
                    );
                    setRecordDataField(
                        newCurrentRecordingFlowChart.tableField,
                        data,
                        data
                    );
                    // return data;
                    // };
                    // const data = await func1(newCurrentRecordingFlowChart);
                    break;

                case "fillListByWorkCombinationTable":
                    await this.fillListByWorkCombinationTable(flowChart, newCurrentRecordingFlowChart, recordData)
                    break;

                case "constant":
                    setRecordDataField(
                        newCurrentRecordingFlowChart.tableField,
                        newCurrentRecordingFlowChart.value,
                        newCurrentRecordingFlowChart.displayValue
                    );
                    break;

                case "dateTime":
                    const date = new Date();
                    setRecordDataField(
                        newCurrentRecordingFlowChart.tableField,
                        dateToString(date, "YYYY-MM-DD HH:mm"),
                        dateToString(date, "DD.MM.YYYY HH:mm")
                    );
                    break;

                case "goRoot":
                    this.pushNewMenu({
                        level: [],
                        flowChart: {...flowChart}
                    });
                    break;

                case "goto":
                    this.pushNewMenu({
                        level: [...newCurrentRecordingFlowChart.level],
                        flowChart: {...flowChart}
                    });
                    break;
                case "restart":
                    let newLevel = [];
                    if (newCurrentRecordingFlowChart.level) {
                        newLevel = [...newCurrentRecordingFlowChart.level];
                    }
                    this.pushNewMenu({
                        level: newLevel,
                        flowChart: {...flowChart}
                    });
                    break;

                case "input":

                    const source = newCurrentRecordingFlowChart.sources[0];
                    if (source === "fromTable" && newCurrentRecordingFlowChart.table === "person") {
                        if (newCurrentRecordingFlowChart.continueIfOnlyOneItem === true) {
                            let list = {}
                            switch (newCurrentRecordingFlowChart.table) {
                                case "person":
                                    list = await getDataFromPersonTable(database);
                                    break;
                                // case "absence":
                                //     list = await getDataFromAbsenceTable(database);
                                //     break;
                                // case "project":
                                //     list = await getDataFromProjectTable(database);
                                //     break;
                                // case "order":
                                //     list = await getDataFromOrderTable(database);
                                //     break;
                                // case "orderItem":
                                //     const orderDbId = this.props.recordData.fields["orderDbId"];
                                //     list = await getDataFromOrderItemTable(database, orderDbId);
                                //     break;
                                // case "costUnit":
                                //     list = await getDataFromCostUnitTable(database);
                                //     break;
                                // case "machine":
                                //     list = await getDataFromMachineTable(database);
                                //     break;
                                // case "workplace":
                                //     list = await getDataFromWorkplaceTable(database);
                                //     break;
                                // case "workprocess":
                                //     list = await getDataFromWorkprocessTable(database);
                                //     break;
                                // case "workCombination":
                                //     list = await getDataFromWorkCombinationTable(database);
                                //     break;
                                default:
                            }
                            if (newCurrentRecordingFlowChart.continueIfOnlyOneItem === true && list.entries.length === 1) {

                                let value = "";
                                let displayValue = "";

                                value = list.entries[0].number;
                                displayValue = list.entries[0].surname;

                                this.setRecordDataFieldAndDbId(
                                    "personDbId", //newCurrentRecordingFlowChart.dbIdTableField,
                                    list.entries[0].dbId, //dbId,
                                    newCurrentRecordingFlowChart.tableField,
                                    value,
                                    displayValue
                                );

                                break;
                            }
                        }
                    }
                case "showOverview":
                default:
                    return newCurrentRecordingFlowChart;

            }
        }
    };

    fillListByWorkCombinationTable = async (flowChart, currentRecordingFlowChart, recordData) => {

        // const {recordData} = this.state;
        const {database} = this.props;

        let list = [];

        const foundList = flowChart.lists.find(list => {
            const result = list.name === currentRecordingFlowChart.targetList.name;
            return result;
        });
        if (foundList === null)
            return;

        switch (currentRecordingFlowChart.sourceTable.name) {
            case "person":
                list = await getDataFromPersonTable(database);
                break;
            case "absence":
                list = await getDataFromAbsenceTable(database);
                break;
            case "project":
                list = await getDataFromProjectTable(database);
                break;
            case "order":
                list = await getDataFromOrderTable(database);
                break;
            case "orderItem":
                const orderDbId = this.props.recordData.fields["orderDbId"];
                list = await getDataFromOrderItemTable(database, orderDbId);
                break;
            case "costUnit":
                list = await getDataFromCostUnitTable(database);
                break;
            case "machine":
                list = await getDataFromMachineTable(database);
                break;
            case "workplace":
                list = await getDataFromWorkplaceTable(database);
                break;
            case "workprocess":
                list = await getDataFromWorkprocessTable(database);
                break;
            case "workCombination":
                if (currentRecordingFlowChart.where.length === 0) {
                    list = await getDataFromWorkCombinationTable(database);
                } else {
                    const where = currentRecordingFlowChart.where[0];
                    list = await getDataFromWorkCombinationTable(database, where.sourceObject, recordData.fields.orderNumber)
                }
                break;
            default:
        }

        if (currentRecordingFlowChart.targetList.clear === true)
            foundList.entries = []

        let dummyUnique = {};
        for (const entryItem of list.entries) {
            let counter = 0;
            let newItem = {};
            for (const sourceItem of currentRecordingFlowChart.sourceTable.fields) {
                newItem[currentRecordingFlowChart.targetList.fields[counter]] = entryItem[currentRecordingFlowChart.sourceTable.object][currentRecordingFlowChart.sourceTable.fields[counter]]
                counter++;
            }
            if (!dummyUnique[newItem.dbId] || currentRecordingFlowChart.targetList.unique !== true) {
                foundList.entries.push(newItem);
                dummyUnique[newItem.dbId] = true;
            }
        }

        foundList.entries = _.orderBy(foundList.entries, ["description"], ["asc"]);

        let lastBooking = null;
        if (recordData && recordData.fields) {
            lastBooking = await LastBookingAccess.getByPersonAndTable(database, recordData.fields["personDbId"], recordData.table)
        }

        switch (currentRecordingFlowChart.sourceTable.object) {
            // case "person":
            //     break;
            // case "absence":
            //     break;
            case "project":
                if (lastBooking && lastBooking.projectDbId) {
                    let lastBookingItem = foundList.entries.find(it => {
                        return (it.dbId === lastBooking.projectDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        foundList.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "order":
                if (lastBooking && lastBooking.orderDbId) {
                    let lastBookingItem = foundList.entries.find(it => {
                        return (it.dbId === lastBooking.orderDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        foundList.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "orderItem":
                if (lastBooking && lastBooking.orderItemDbId) {
                    let lastBookingItem = foundList.entries.find(it => {
                        return (it.dbId === lastBooking.orderItemDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        foundList.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "costUnit":
                if (lastBooking && lastBooking.costUnitDbId) {
                    let lastBookingItem = foundList.entries.find(it => {
                        return (it.dbId === lastBooking.costUnitDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        foundList.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "machine":
                if (lastBooking && lastBooking.machineDbId) {
                    let lastBookingItem = foundList.entries.find(it => {
                        return (it.dbId === lastBooking.machineDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        foundList.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "workplace":
                if (lastBooking && lastBooking.workplaceDbId) {
                    let lastBookingItem = foundList.entries.find(it => {
                        return (it.dbId === lastBooking.workplaceDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        foundList.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "workprocess":
                if (lastBooking && lastBooking.workprocessDbId) {
                    let lastBookingItem = foundList.entries.find(it => {
                        return (it.dbId === lastBooking.workprocessDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        foundList.entries.unshift(lastBookingItem);
                    }
                }
                break;
            default:
        }

    }

    getHttpRequest = async newCurrentRecordingFlowChart => {
        // const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
        let fields = {...this.state.recordData.fields};
        const {credentials} = this;
        const {configurations} = this.props;
        let urlParameter = "";
        if (
            newCurrentRecordingFlowChart.parameter1Key &&
            newCurrentRecordingFlowChart.parameter1Value
        ) {
            urlParameter +=
                newCurrentRecordingFlowChart.parameter1Key +
                "=" +
                this.state.recordData.fields[
                    newCurrentRecordingFlowChart.parameter1Value
                    ];
        }
        if (
            newCurrentRecordingFlowChart.parameter2Key &&
            newCurrentRecordingFlowChart.parameter2Value
        ) {
            urlParameter +=
                newCurrentRecordingFlowChart.parameter2Key +
                "=" +
                this.state.recordData.fields[
                    newCurrentRecordingFlowChart.parameter2Value
                    ];
        }

        const url =
            getApiUrl() +
            "/" +
            newCurrentRecordingFlowChart.controllerName +
            "?" +
            urlParameter +
            `&mandatoryNumber=${configurations.mandatoryNumber}`;

        const request = await getWithJWT(credentials, url);
        return request.data.data;
    };

    onSetCredentials = async (credentials, rerender) => {
        const {database} = this.props;

        if (!credentials) return;

        const {username, access_token, refresh_token} = credentials;
        this.credentials["username"] = username;
        this.credentials["tokens"]["access_token"] = access_token;
        this.credentials["tokens"]["refresh_token"] = refresh_token;
        this.prepareNewMenu(null, null);

        // Daten vom Server abfragen
        await this.loadWebAppConfiguration();

        // TODO: die Daten nur holen, wenn es im Ablauf definiert ist
        let doLoadWebAppData = false;
        const lastSynchronisationRecord = await SystemLogAccess.getByName(
            database,
            systemLogTable,
            "lastSynchronisation"
        );
        if (lastSynchronisationRecord) {
            if (lastSynchronisationRecord.value == "unknown") {
                doLoadWebAppData = true;
            } else {
                const lastSynchronisationDate = stringToDate(
                    lastSynchronisationRecord.value,
                    "YYYYMMDDHHmmss"
                );
                const today = new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    new Date().getDate()
                );
                if (lastSynchronisationDate < today) doLoadWebAppData = true;
            }
        }

        // doLoadWebAppData = true; // TODO
        if (doLoadWebAppData === true) {
            await this.onSynchroniseWebAppData()
        }

        if (rerender === true) {
            this.setState({});
        }
    };

    onLogout = () => {
        this.credentials.username = "";
        this.setState({});
    };

    onSynchroniseWebAppData = async () => {
        const {database} = this.props;

        this.setState({webAppDataLoading: true, showWebAppDataLoadingSummary: false});

        const summary = await this.loadWebAppData();

        const lastSynchronisationRecord = await SystemLogAccess.getByName(
            database,
            systemLogTable,
            "lastSynchronisation"
        );
        if (lastSynchronisationRecord) {
            await SystemLogAccess.updateById(
                database,
                systemLogTable,
                lastSynchronisationRecord.id,
                {
                    name: "lastSynchronisation",
                    value: dateToString(new Date(), "YYYYMMDDHHmmss")
                }
            );
        }


        if (summary && (
            (summary.personCount && summary.personCount > 0) ||
            (summary.absenceCount && summary.absenceCount > 0) ||
            (summary.projectCount && summary.projectCount > 0) ||
            (summary.orderCount && summary.orderCount > 0) ||
            (summary.orderItemCount && summary.orderItemCount > 0) ||
            (summary.costUnitCount && summary.costUnitCount > 0) ||
            (summary.machineCount && summary.machineCount > 0) ||
            (summary.workplaceCount && summary.workplaceCount > 0) ||
            (summary.workprocessCount && summary.workprocessCount > 0) ||
            (summary.workCombinationCount && summary.workCombinationCount > 0)
        )) {
            this.setState({
                webAppDataLoading: false,
                webAppDataLoadingSummary: summary,
                showWebAppDataLoadingSummary: true
            });
        } else {
            this.setState({webAppDataLoading: false});
        }

    };

    onShowWebAppDataLoadingSummary = (show) => {
        this.setState({showWebAppDataLoadingSummary: show});
    };

    render = () => {
        const {
            level,
            flowChart,
            currentFlowChart,
            currentRecordingFlowChart,
            recordData,
            webAppDataLoading,
            showWebAppDataLoadingSummary,
            webAppDataLoadingSummary
        } = this.state;
        const {database, configurations, handleSetConfigurations} = this.props;
        const {credentials, onSetCredentials, onShowWebAppDataLoadingSummary} = this;

        if (
            !configurations ||
            !configurations.mandatoryNumber ||
            !configurations.deviceSerialNumber ||
            configurations.mandatoryNumber.length === 0 ||
            configurations.deviceSerialNumber.length === 0 ||
            !credentials ||
            !credentials.username
        ) {
            if (
                !configurations ||
                !configurations.mandatoryNumber ||
                !configurations.deviceSerialNumber ||
                configurations.mandatoryNumber.length === 0 ||
                configurations.deviceSerialNumber.length === 0
            ) {
                return (
                    <MobileSystemConfigurationListForm
                        flowChart={flowChart}
                        currentFlowChart={{title: {text: "system configurations"}}}
                        currentRecordingFlowChart={currentRecordingFlowChart}
                        recordData={recordData}
                        setRecordData={this.setRecordData}
                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                        setRecordDataField={this.setRecordDataField}
                        setCurrentRecordingFlowChart={this.setCurrentRecordingFlowChart}
                        pushNewMenu={this.pushNewMenu}
                        database={database}
                        configurations={configurations}
                        handleSetConfigurations={handleSetConfigurations}
                    />
                );
            }

            if (!credentials || !credentials.username) {
                return (
                    <LoginForm
                        handleSetCredentials={onSetCredentials}
                        configurations={configurations}
                        handleSetConfigurations={handleSetConfigurations}
                    ></LoginForm>
                );
            }
        }
// console.log("Mobile.render(): webAppDataLoading=", webAppDataLoading, ", showWebAppDataLoadingSummary=", showWebAppDataLoadingSummary);
        if (webAppDataLoading === true || showWebAppDataLoadingSummary === true) {
            return <WebAppDataLoading
                showWebAppDataLoadingSummary={showWebAppDataLoadingSummary}
                webAppDataLoadingSummary={webAppDataLoadingSummary}
                handleShowWebAppDataLoadingSummary={onShowWebAppDataLoadingSummary}
                text={"Daten vom Server holen ..."}
            />
        }

        // if (
        //   flowChart.configuration === null ||
        //   flowChart.configuration === undefined
        // ) {
        //   return <React.Fragment></React.Fragment>;
        // }

        // if (level.length === 0) {
        // } else {
        switch (currentFlowChart.type) {
            case undefined: // Anzeige vom Hauptmenue
            case "menu":
                return (
                    <MobileMenu
                        level={level}
                        flowChart={flowChart}
                        currentFlowChart={currentFlowChart}
                        pushNewMenu={this.pushNewMenu}
                        credentials={credentials}
                        handleLogout={this.onLogout}
                        handleSynchroniseWebAppData={this.onSynchroniseWebAppData}
                    />
                );
            // case "list":
            case "recording":
                if (currentRecordingFlowChart === null) {
                    return <React.Fragment></React.Fragment>;
                }
                switch (currentRecordingFlowChart.type) {
                    case "showOverview":
                        return (
                            <MobileRecordingShowOverview
                                flowChart={flowChart}
                                currentFlowChart={currentFlowChart}
                                currentRecordingFlowChart={currentRecordingFlowChart}
                                recordData={recordData}
                                setRecordData={this.setRecordData}
                                getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                                setRecordDataField={this.setRecordDataField}
                                setCurrentRecordingFlowChart={this.setCurrentRecordingFlowChart}
                                pushNewMenu={this.pushNewMenu}
                            />
                        );
                    case "input":
                        // TODO: sources
                        const source = currentRecordingFlowChart.sources[0];
                        switch (source) {
                            case "numberList":
                                return (
                                    <MobileRecordingNumberList
                                        flowChart={flowChart}
                                        currentFlowChart={currentFlowChart}
                                        currentRecordingFlowChart={currentRecordingFlowChart}
                                        recordData={recordData}
                                        setRecordData={this.setRecordData}
                                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                                        setRecordDataField={this.setRecordDataField}
                                        setCurrentRecordingFlowChart={
                                            this.setCurrentRecordingFlowChart
                                        }
                                        source={source}
                                        pushNewMenu={this.pushNewMenu}
                                    />
                                );
                            case "fromList":
                                return (
                                    <MobileRecordingFromList
                                        key={new Date().getTime()} // damit wird componentDidMount jedenfalls ausgefuehrt - auch wenn diese Componente zweimal hintereinander gestartet wird
                                        // -> searchText ist deshalb auch auf Leerstring zurueckgesetzt
                                        flowChart={flowChart}
                                        currentFlowChart={currentFlowChart}
                                        currentRecordingFlowChart={currentRecordingFlowChart}
                                        recordData={recordData}
                                        setRecordData={this.setRecordData}
                                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                                        setRecordDataFieldAndDbId={this.setRecordDataFieldAndDbId}
                                        setCurrentRecordingFlowChart={
                                            this.setCurrentRecordingFlowChart
                                        }
                                        source={source}
                                        pushNewMenu={this.pushNewMenu}
                                    />
                                );
                            case "fromTable":
                                return (
                                    <MobileRecordingFromTable
                                        key={new Date().getTime()} // damit wird componentDidMount jedenfalls ausgefuehrt - auch wenn diese Componente zweimal hintereinander gestartet wird
                                        // -> searchText ist deshalb auch auf Leerstring zurueckgesetzt
                                        flowChart={flowChart}
                                        currentFlowChart={currentFlowChart}
                                        currentRecordingFlowChart={currentRecordingFlowChart}
                                        recordData={recordData}
                                        setRecordData={this.setRecordData}
                                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                                        setRecordDataFieldAndDbId={this.setRecordDataFieldAndDbId}
                                        setCurrentRecordingFlowChart={
                                            this.setCurrentRecordingFlowChart
                                        }
                                        source={source}
                                        pushNewMenu={this.pushNewMenu}
                                        database={database}
                                    />
                                );
                            case "numberBlock":
                                return (
                                    <MobileRecordingNumberBlock
                                        flowChart={flowChart}
                                        currentFlowChart={currentFlowChart}
                                        currentRecordingFlowChart={currentRecordingFlowChart}
                                        recordData={recordData}
                                        setRecordData={this.setRecordData}
                                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                                        setRecordDataField={this.setRecordDataField}
                                        setCurrentRecordingFlowChart={
                                            this.setCurrentRecordingFlowChart
                                        }
                                        source={source}
                                        pushNewMenu={this.pushNewMenu}
                                    />
                                );
                            case "alphaNumberBlock":
                                return (
                                    <MobileRecordingAlphaNumberBlock
                                        flowChart={flowChart}
                                        currentFlowChart={currentFlowChart}
                                        currentRecordingFlowChart={currentRecordingFlowChart}
                                        recordData={recordData}
                                        setRecordData={this.setRecordData}
                                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                                        setRecordDataField={this.setRecordDataField}
                                        setCurrentRecordingFlowChart={
                                            this.setCurrentRecordingFlowChart
                                        }
                                        source={source}
                                        pushNewMenu={this.pushNewMenu}
                                    />
                                );
                            case "keyboard":
                                return (
                                    <MobileRecordingKeyboard
                                        flowChart={flowChart}
                                        currentFlowChart={currentFlowChart}
                                        currentRecordingFlowChart={currentRecordingFlowChart}
                                        recordData={recordData}
                                        setRecordData={this.setRecordData}
                                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                                        setRecordDataField={this.setRecordDataField}
                                        setCurrentRecordingFlowChart={
                                            this.setCurrentRecordingFlowChart
                                        }
                                        source={source}
                                        pushNewMenu={this.pushNewMenu}
                                    />
                                );
                            case "nfcReader":
                                return (
                                    <MobileRecordingNfcReader
                                        flowChart={flowChart}
                                        currentFlowChart={currentFlowChart}
                                        currentRecordingFlowChart={currentRecordingFlowChart}
                                        recordData={recordData}
                                        setRecordData={this.setRecordData}
                                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                                        setRecordDataField={this.setRecordDataField}
                                        setCurrentRecordingFlowChart={
                                            this.setCurrentRecordingFlowChart
                                        }
                                        source={source}
                                        pushNewMenu={this.pushNewMenu}
                                    />
                                );
                            case "HtmlInputField-time":
                            case "HtmlInputField-date":
                            case "HtmlInputField-datetime":
                            case "HtmlInputField-text":
                            case "HtmlInputField-number":
                                return (
                                    <MobileRecordingHtmlInputField
                                        flowChart={flowChart}
                                        currentFlowChart={currentFlowChart}
                                        currentRecordingFlowChart={currentRecordingFlowChart}
                                        recordData={recordData}
                                        setRecordData={this.setRecordData}
                                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                                        setRecordDataField={this.setRecordDataField}
                                        setCurrentRecordingFlowChart={
                                            this.setCurrentRecordingFlowChart
                                        }
                                        source={source}
                                        pushNewMenu={this.pushNewMenu}
                                    />
                                );
                            default:
                        }
                        break;
                    default:
                        return <React.Fragment></React.Fragment>;
                }
                break;

            case "localBookingStorage":
                // TODO: unsauber
                return (
                    <MobileLocalBookingStorageListForm
                        flowChart={flowChart}
                        currentFlowChart={currentFlowChart}
                        currentRecordingFlowChart={currentRecordingFlowChart}
                        recordData={recordData}
                        setRecordData={this.setRecordData}
                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                        setRecordDataField={this.setRecordDataField}
                        setCurrentRecordingFlowChart={this.setCurrentRecordingFlowChart}
                        pushNewMenu={this.pushNewMenu}
                        database={database}
                    />
                );

            case "systemConfiguration":
                // TODO: unsauber
                return (
                    <MobileSystemConfigurationListForm
                        flowChart={flowChart}
                        currentFlowChart={currentFlowChart}
                        currentRecordingFlowChart={currentRecordingFlowChart}
                        recordData={recordData}
                        setRecordData={this.setRecordData}
                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                        setRecordDataField={this.setRecordDataField}
                        setCurrentRecordingFlowChart={this.setCurrentRecordingFlowChart}
                        pushNewMenu={this.pushNewMenu}
                        database={database}
                        handleSetConfigurations={handleSetConfigurations}
                    />
                );

            case "systemLog":
                // TODO: unsauber
                return (
                    <MobileSystemLogListForm
                        flowChart={flowChart}
                        currentFlowChart={currentFlowChart}
                        currentRecordingFlowChart={currentRecordingFlowChart}
                        recordData={recordData}
                        setRecordData={this.setRecordData}
                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                        setRecordDataField={this.setRecordDataField}
                        setCurrentRecordingFlowChart={this.setCurrentRecordingFlowChart}
                        pushNewMenu={this.pushNewMenu}
                        database={database}
                        handleSetConfigurations={handleSetConfigurations}
                    />
                );

            case "doorVisualisation":
                // TODO: unsauber
                return (
                    <MobileDoorVisualisationListForm
                        flowChart={flowChart}
                        currentFlowChart={currentFlowChart}
                        currentRecordingFlowChart={currentRecordingFlowChart}
                        recordData={recordData}
                        setRecordData={this.setRecordData}
                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                        setRecordDataField={this.setRecordDataField}
                        setCurrentRecordingFlowChart={this.setCurrentRecordingFlowChart}
                        pushNewMenu={this.pushNewMenu}
                        database={database}
                        handleSetConfigurations={handleSetConfigurations}
                        credentials={credentials}
                    />
                );

            case "logisticsPlanning":
                // TODO: unsauber
                return (
                    <MobileLogisticsPlanningListForm
                        flowChart={flowChart}
                        currentFlowChart={currentFlowChart}
                        currentRecordingFlowChart={currentRecordingFlowChart}
                        recordData={recordData}
                        setRecordData={this.setRecordData}
                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                        setRecordDataField={this.setRecordDataField}
                        setCurrentRecordingFlowChart={this.setCurrentRecordingFlowChart}
                        pushNewMenu={this.pushNewMenu}
                        database={database}
                        handleSetConfigurations={handleSetConfigurations}
                        credentials={credentials}
                    />
                );

            case "shiftPlanning":
                // TODO: unsauber
                return (
                    <MobileShiftPlanningListForm
                        flowChart={flowChart}
                        currentFlowChart={currentFlowChart}
                        currentRecordingFlowChart={currentRecordingFlowChart}
                        recordData={recordData}
                        setRecordData={this.setRecordData}
                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                        setRecordDataField={this.setRecordDataField}
                        setCurrentRecordingFlowChart={this.setCurrentRecordingFlowChart}
                        pushNewMenu={this.pushNewMenu}
                        database={database}
                        handleSetConfigurations={handleSetConfigurations}
                        credentials={credentials}
                    />
                );

            case "workPeriod":
                // TODO: unsauber
                return (
                    <MobileWorkPeriodListForm
                        flowChart={flowChart}
                        currentFlowChart={currentFlowChart}
                        currentRecordingFlowChart={currentRecordingFlowChart}
                        recordData={recordData}
                        setRecordData={this.setRecordData}
                        getNextRecordingFlowChart={this.getNextRecordingFlowChart}
                        setRecordDataField={this.setRecordDataField}
                        setCurrentRecordingFlowChart={this.setCurrentRecordingFlowChart}
                        pushNewMenu={this.pushNewMenu}
                        database={database}
                        handleSetConfigurations={handleSetConfigurations}
                        credentials={credentials}
                    />
                );

            default:
                return <React.Fragment></React.Fragment>;
        }
        // }
    }
}

export default Mobile;
